import gql from 'graphql-tag';

export const NetworkStatusListenerQuery = gql`
	query NetworkStatusListenerQuery {
		network {
			status
		}
	}
`;
